import { render } from "./PanelAIPressResult.vue?vue&type=template&id=7654a203&scoped=true"
import script from "./PanelAIPressResult.vue?vue&type=script&lang=js"
export * from "./PanelAIPressResult.vue?vue&type=script&lang=js"

import "./PanelAIPressResult.vue?vue&type=style&index=0&id=7654a203&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\user\\IdeaProjects\\aipr-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7654a203"]])

export default __exports__